import { render } from "./AnalyticsIncorrects.vue?vue&type=template&id=6372d659&scoped=true"
import script from "./AnalyticsIncorrects.vue?vue&type=script&lang=js"
export * from "./AnalyticsIncorrects.vue?vue&type=script&lang=js"

import "@/css/components/analytics-incorrects.css?vue&type=style&index=0&id=6372d659&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6372d659"]])

export default __exports__